import React from 'react'
import YearlyBudgetFormView from '../../../../components/account/report/year_budger_rpt/YearlyBudgetFormView'

const YearlyBudgetReportFormView = () => {
  return (
    <div>
      <YearlyBudgetFormView />
    </div>
  )
}

export default YearlyBudgetReportFormView
